export default "__VITE_ASSET__DDQqbEOX__"